import { createContext, useContext, useState, type ReactNode } from "react";

interface Settings {
  hapticEnabled: boolean;
  setHapticEnabled: (v: boolean) => void;
}

const SettingsContext = createContext<Settings>({
  hapticEnabled: true,
  setHapticEnabled: () => {},
});

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [hapticEnabled, setHapticEnabled] = useState(true);
  return (
    <SettingsContext.Provider value={{ hapticEnabled, setHapticEnabled }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
